import { useEffect } from 'react';

import { useChatComposerCallbacks } from '../chat-composer-contexts';
import type { ChatContext } from '../chat-context-types';

export const useRegisterChatContext = (tileId: string, context: ChatContext | undefined): void => {
    const { registerChatContext, unregisterChatContext } = useChatComposerCallbacks();

    // Effect re-fires on every render when callers pass an inline literal,
    // but the registry shallow-equals on its side and bails out, so consumers
    // don't see spurious updates.
    useEffect(() => {
        if (context === undefined) {
            unregisterChatContext(tileId);
            return;
        }
        registerChatContext(tileId, context);
    }, [tileId, context, registerChatContext, unregisterChatContext]);

    useEffect(() => {
        return () => unregisterChatContext(tileId);
    }, [tileId, unregisterChatContext]);
};
